// the most terrible camelizer on the internet, guaranteed!
export const camelCase = (text: string) =>
	`${text.charAt(0).toLowerCase()}${text
		.replaceAll(/[\W_]/g, "|")
		.split("|")
		.map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
		.join("")
		.slice(1)}`;
